module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Relatórios de gestão'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRelatoriosGestao,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "grid_on",
            "color": "primary",
            "tooltip": "Baixar planilha"
          },
          on: {
            "click": function($event) {
              return _vm.goPlanilhaRelatorio(props.item.id, props.item.nome)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaRelatoriosGestao.length) + " projetos\n            ")]
      }
    }], null, false, 3359232442)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d39df92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/relatorios-gestao-tabela.vue
// module id = 718
// module chunks = 0